import { EChartTimeseries } from "../../../components/EChartTimeseries.js";
import { useMemoizedBarSeries } from "../../../hooks/chart.js";
import { type SpecificUsageChartProps, UsageChartWrapper } from "./UsageChartWrapper.js";
import { IconChartLine } from "@tabler/icons-react";
import { TieredPriceProductId } from "@project/common";
import { checkIsApproachingLimit } from "./utils/limits.js";
import { useStyleJsonUsage } from "./hooks/fetchUsages.js";
import { useProductNames } from "./hooks/productLabels.js";

export const MapLoadsUsageChart = ({
  from,
  to,
  interval,
  apiKeyId,
  addToDetailedView,
}: SpecificUsageChartProps) => {
  const getName = useProductNames();

  const {
    styleJsonUsage,
    isLoadingStyleJsonUsage,
    isErrorStyleJsonUsage,
  } = useStyleJsonUsage({ from, to, interval, apiKeyId });

  const title = getName(TieredPriceProductId.TieredMapSession);
  const series = useMemoizedBarSeries(styleJsonUsage, title);

  return (
    <UsageChartWrapper
      title={title}
      iconColor="orange.8"
      hasUsage={styleJsonUsage.length > 0}
      isLoading={isLoadingStyleJsonUsage}
      hasError={isErrorStyleJsonUsage}
      icon={<IconChartLine size={20} />}
      addToDetailedView={addToDetailedView}
      isApproachingLimit={checkIsApproachingLimit(styleJsonUsage, TieredPriceProductId.TieredMapSession)}
    >
      <EChartTimeseries series={series} />
    </UsageChartWrapper>
  );
};
